export default "__VITE_ASSET__Db69QFCo__"